(($) => {
  $(() => {
    const $alert = $('#alert');

    if ($alert.length) {
      const localStorageKey = 'alertDismissed';
      const localStorageValue = btoa($alert.find('.alert__message').text());

      if (localStorage.getItem(localStorageKey) !== localStorageValue) {
        $alert.show();
      }

      $alert.on('click', '.btn-close', () => {
        localStorage.setItem(localStorageKey, localStorageValue);
      });
    }
  });
})(jQuery);
